// i18n area 'storage' — locale is-IS (task #171, ratifica Luca 2026-08-04: l'islandese
// entra come 28ª lingua): tradotto DALL'ITALIANO (lingua SORGENTE, regola
// 2026-08-03). Glossario di sezione: geymsla (storage), katalógur (catalogo),
// klóna (clonare), ættleiða (adottare), skönnun (scansione), glötuð (perduta),
// deilt (condiviso), nafnrými (namespace), tengd afrit (copie collegate),
// innbyggt (integrato); restano invariati share, pool, thin, mount, checksum,
// linked clone, seed, qcow2, portal, IQN/LUN/NQN/NSID, CHAP/cephx, RBD, CephFS.
// Sidecar anti-stantie: ../meta/storage.is-IS.meta.json.
import type { enUS } from './storage'

export const isIS: typeof enUS = {
  storage: {
    pools: {
      title: 'Geymslur',
      createTitle: 'Búa til geymslu',
      path: 'Slóð',
      pathHint: 'Alger slóð undir leyfðri rót (sjálfgefið /var/lib/tvirt/pools/)',
      shared: 'Deild geymsla',
      sharedChip: 'deild',
      sharedVerifiedChip: 'deild · sannreynd',
      sharedVerifiedTooltip: 'Deiling sannreynd: krosskannanirnar staðfesta að hver meðlimur sér gögnin sem hinir skrifa.',
      sharedDisputedChip: 'deild · EKKI sannreynd',
      sharedDisputedTooltip: 'Deiling EKKI sannreynd',
      sharedDisputedPair: '{observer} sér ekki gögnin sem {writer} skrifar',
      sharedHint: 'Netshare tengd staðbundið á sömu slóð á hverjum meðlim — forsenda live migration (yfirlýsing).',
      sharedDanger: 'HÆTTA — TVirt TRÚIR þessum rofa: sé kveikt á honum gerir hver meðlimur ráð fyrir að sjá SÖMU bætin á þessari slóð. Á möppu sem er EKKI raunverulega deild share (NFS/CIFS/klasaskráakerfi) er niðurstaðan gagnaspilling og gagnatap við fyrsta flutning eða fyrstu HA-endurræsingu á öðrum hnút. Kveiktu aðeins á honum ef slóðin er share tengd eins á hverjum hnút.',
      type: 'Tegund',
      capacity: 'Rýmd',
      provisioned: 'Úthlutað',
      provisionedOvercommit: 'Möguleg skuldbinding umfram rýmd: thin-volume geta vaxið upp í {n} GiB.',
      phase: { ready: 'Tilbúin', degraded: 'Skert', error: 'Villa' },

      // Round #156 (dialog standard): il dialog dettagli COMPLETO — tab,
      // le righe di config per-driver e la superficie osservata.
      tabConfig: 'Stillingar',
      tabCapacity: 'Rýmd og staða',
      cardIdentity: 'Auðkenni',
      cardPlacement: 'Staðsetning',
      cardConnection: 'Tenging',
      usedReal: 'Raunveruleg notkun',
      capacityUnknown: 'Hnúturinn hefur ekki enn gefið upp rýmd þessa pools — hér eru tölur ekki fundnar upp',
      overcommitHint: 'Skuldbinding umfram rýmd: lögmæt á thin-poolum, fylgstu með raunverulegu notkuninni',
      supportedContent: 'Stutt innihald',
      content: {
        disks: 'Diskar',
        catalogFiles: 'Katalógskrár',
        backups: 'Afrit',
        appVolumes: 'App-volume'
      },
      defaultDiskFormat: 'Sjálfgefið disksnið',
      reserveGiB: 'Frátekið laust pláss (GiB)',
      available: 'Tiltækt',
      diskCount: 'Diskar',
      filesystem: 'Skráakerfi',
      observedAt: 'Athuguð þann',
      lostAtRow: 'Lýst glötuð þann',
      sharedProbeRow: 'Sannprófun deilingar',
      sharedProbeNodes: 'Kannaðir hnútar',
      reachableFrom: 'Yfirlýst náanleiki',
      reachableFromHint: 'Hnútarnir sem þessi geymsla á að vera náanleg frá. VM með diska, ISO eða lýsigögn hér ræsist hvorki né flyst á hnút utan þessa lista. Allir meðlimir eru forvaldir: þrengdu að vild. Hnútur sem gengur í klasann síðar stendur utan við þar til þú bætir honum við hér.',
      reachableFromNone: 'ekki yfirlýst',
      reachableFromTags: 'Náanleiki eftir merkjum',
      reachableFromTagsHint: 'Veljari merki=gildi (færslur aðskildar með kommu, í AND): hver meðlimur sem ber þessi merki er lýstur náanlegur — kvikt: að merkja hnút hleypir honum inn.',
      reachableFromTagsInvalid: 'Ógilt snið — notaðu merki=gildi, aðskilin með kommu',
      reachableResolved: 'Uppleystir hnútar: {nodes}',
      reachableDeclaredNotSeen: 'yfirlýst en ekki séð af deilingarkönnuninni á: {nodes}',
      reachableSeenNotDeclared: 'séð en ekki yfirlýst (utan jaðars) á: {nodes}',
      cephCluster: 'Stýrður Ceph-klasi',
      appGuardTitle: 'Geymsla í notkun hjá öppum',
      appEphemeralGuard: 'þessi geymsla er hverfula klasa-pool appanna — skiptu um hana fyrst af Öpp-síðunni, eyddu henni svo.',
      appInUseGuard: 'hér búa root/volume appa: {apps} — flyttu þau eða eyddu þeim fyrst.',
      releaseRequiredTitle: "Eyða '{name}' og losa myndir þess?",
      releaseRequiredBatchTitle: 'Eyða völdum storage og losa myndir þeirra?',
      releaseRequiredBody: 'Að losa myndirnar eyðir ENGU bæti: afskráningin skilur namespace eftir á disknum, myndirnar hætta einfaldlega að vera efnisgerðar og hver tilvísun scope lifir áfram sem claim — skráðu poolinn aftur og þær eru ættleiddar á ný.',
      releaseConfirm: 'Eyða og losa myndirnar'
    },
    lost: {
      chip: 'Glötuð',
      action: 'Lýsa glataða',
      confirmTitle: 'Lýsa geymsluna glataða',
      confirmBody: 'Staðfesting rekstraraðilans á eigin yfirlýstri ábyrgð: hvert verk í biðröð eða í gangi á þessari geymslu eða hlutum hennar MUN MISTAKAST, eyðingar verða aðeins í skránni (engin vinna á skráakerfinu) og nýrri efnislegri vinnu er hafnað. Bætin eru aldrei snert — vakni gagnahirslan aftur til lífsins, skráðu hana á ný og keyrðu skönnun til að ættleiða allt aftur.',
      confirmSubmit: 'Lýsa glataða',
      error: 'Staðfestingunni var hafnað'
    },
    findings: {
      action: 'Fundnir hlutir',
      title: 'Fundnir hlutir',
      empty: 'Enginn hlutur fundinn í nafnrými geymslunnar',
      loadError: 'Ekki tókst að sækja fundnu hlutina',
      actionError: 'Ákvörðuninni var hafnað',
      colKind: 'Tegund',
      colObject: 'Hlutur',
      colConflict: 'Árekstur',
      namespaceNotice:
        'Þessi mappa hafði þegar verið frumstillt af annarri geymslu: auðkennisinnsiglinu hefur verið skipt út fyrir innsigli þessarar geymslu. Innihaldinu var EKKI breytt — skoðaðu hlutina sem fundust hér að neðan, flyttu inn þá sem þú þarft og lokaðu svo þessari tilkynningu.',
      kind: {
        disk: 'Diskur',
        catalogFile: 'Katalógskrá',
        vmMetadata: 'VM-lýsigögn',
        namespace: 'Nafnrými',
        foreign: 'Óskyldur',
        volumeGroup: 'Sniðmagnahópur'
      },
      vgAdopt: {
        action: 'Ættleiða sniðmagnahóp',
        title: 'Ættleiða sniðmagnahóp',
        intro:
          'Þetta tæki ber þegar sniðmagnahóp með TVirt-nafni, en innsigli hans nefnir ekkert storage sem skráð er hér. Það getur verið það sem fyrra storage ÞESSA klasa skildi eftir á LUN — eða það sem ANNAR TVirt-klasi skildi eftir á LUN sem skipti um hendur: héðan líta bæði tilvikin eins út, og þess vegna ákveður enginn fyrir þig.',
        irreversible: 'Skoðaðu tækið, innsiglið og nafnið áður en þú heldur áfram: ættleiðingin verður ekki afturkölluð.',
        device: 'Tæki',
        seal: 'Innsigli',
        sealNone: 'ekkert (ekkert tvirt.storageId-merki)',
        renameTo: 'Verður endurnefnt í',
        renameNone: 'Engin endurnefning: nafnið er þegar það sem þetta storage leiðir af sér',
        volumesNote:
          'Sniðmögnin innan í eru EKKI ættleidd með þessari aðgerð: næsta skönnun býður þau eitt af öðru, sem venjuleg fundin fyrirbæri.'
      },
      conflictChip: 'ID þegar til',
      dismissedChip: 'Hunsað',
      adopt: 'Ættleiða',
      adoptFileTitle: 'Flytja inn í katalóg',
      adoptFileHint: 'Skrár eru aðeins til inni í katalógum: veldu áfangakatalóginn fyrir fundnu skrána.',
      purge: 'Eyða af diskinum',
      dismiss: 'Hunsa',
      purgeConfirmTitle: 'Eyða af diskinum',
      purgeConfirmBody: 'Fundnu bæti {id} verða fjarlægð af geymslunni. Aðgerðin er óafturkræf.',
      taskStarted: 'Hafið — heldur áfram sem verk í bakgrunni',
      scan: 'Skanna geymsluna',
      scanStarted: 'Skönnun hafin…',
      scanDone: 'Skönnun lokið — fundnu hlutirnir eru uppfærðir'
    },
    reinit: {
      action: 'Reyna frumstillingu aftur'
    },
    wizard: {
      addButton: 'Bæta við',
      title: 'Bæta við geymslu',
      back: 'Til baka',
      continue: 'Áfram',
      selectHint: 'Veldu samskiptareglu til að sjá hvernig TVirt notar hana.',
      roadmap: 'Vegvísir',
      server: 'Þjónn',
      export: 'Útflutt slóð',
      share: 'Share',
      username: 'Notandanafn',
      password: 'Lykilorð',
      passwordHint: 'Aðeins skrifað: notað við mount, aldrei sýnt aftur.',
      credential: 'Aðgangsupplýsingar',
      credentialManual: 'Slá inn handvirkt',
      credentialHint: 'Keystore-færsla af gerðinni notandanafn og lykilorð — valkosturinn við að slá þau inn hér.',
      credentialEmpty: 'Engar aðgangsupplýsingar af gerðinni notandanafn og lykilorð í keystore — búðu þær til í Kerfi → Aðgangsupplýsingar, eða sláðu reikninginn inn hér fyrir neðan.',
      options: 'Mount-valkostir',
      optionsHint: 'Aðskildir með kommu, réttir mount -o eins og þeir eru.',
      portal: 'Portal',
      portalHint: 'hýsill[:port] — sjálfgefna portið er 3260.',
      target: 'Target IQN',
      targetHint: 'Nafn iSCSI-targetsins, byrjar á iqn.',
      lun: 'LUN',
      wholeLunRow: 'Á diskunum: þessi geymsla nefnir aðeins markmiðið',
      wholeLunHint: 'Þessi geymsla nefnir aðeins markmiðið: LUN hennar verða diskar eitt í einu (Búa til disk → taka yfir heilt LUN), ekkert er skrifað á markmiðið.',
      lunHint: 'Númer LUN á targetinu — 0 í vafa.',
      chapCredential: 'Aðgangsupplýsingar (CHAP)',
      chapCredentialHint: 'Keystore-færsla af gerðinni CHAP (iSCSI) notuð við innskráninguna — leyndarmálið ferðast aldrei með geymslunni.',
      chapNone: 'Engin auðkenning',
      chapEmpty: 'Engar aðgangsupplýsingar af gerðinni CHAP (iSCSI) í keystore — búðu þær til í Kerfi → Aðgangsupplýsingar. Án þeirra helst innskráningin óauðkennd.',
      address: 'Vistfang',
      addressHint: 'Hýsill eða IP NVMe/TCP-targetsins (traddr).',
      port: 'Port',
      portHint: 'TCP-port targetsins — 4420 sé það skilið eftir autt.',
      targetNqn: 'Target NQN',
      targetNqnHint: 'NQN undirkerfisins á targetinu, byrjar á nqn.',
      nsid: 'NSID',
      nsidHint: 'Namespace ID innan undirkerfisins — 1 í vafa.',
      dhchapCredential: 'Aðgangsupplýsingar (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'Keystore-færsla af gerðinni DH-HMAC-CHAP (NVMe) notuð við tenginguna — leyndarmálið ferðast aldrei með geymslunni.',
      dhchapNone: 'Engin auðkenning',
      dhchapEmpty: 'Engar aðgangsupplýsingar af gerðinni DH-HMAC-CHAP (NVMe) í keystore — búðu þær til í Kerfi → Aðgangsupplýsingar. Án þeirra helst tengingin óauðkennd.',
      monitors: 'Monitor',
      monitorsHint: 'Endapunktar Ceph-monitoranna, hýsill[:port], aðskildir með kommu eða línuskiptum — sjálfgefið port 6789.',
      pool: 'Pool',
      poolHint: 'RBD-pool-ið sem á að neyta — ein RBD-mynd á disk.',
      fs: 'Skráakerfi',
      fsHint: 'Nafn CephFS-skráakerfisins (mds_namespace við mount).',
      fsPath: 'Slóð innan skráakerfisins',
      fsPathHint: 'Alger slóð innan skráakerfisins sem geymslan tengir — / í vafa.',
      cephxCredential: 'Aðgangsupplýsingar (cephx)',
      cephxCredentialHint: 'Keystore-færsla af gerðinni cephx: notandanafn = nafn biðlarans (client.…), leyndarmál = base64-lykillinn. Skylda.',
      cephxNone: 'Engar cephx-aðgangsupplýsingar í keystore — búðu til færslu (tegund: cephx) í Kerfi → Aðgangsupplýsingar, eða láttu stýrðan Ceph-klasa mynta hana með „Bjóða fram sem geymslu“.',
      sharedByNature: 'Netgeymslur eru deildar í eðli sínu: hver meðlimur tengir þær á sömu slóð stýrða af TVirt.',
      error: 'Geymslunni var hafnað',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Annað',
        legacy: 'Legacy'
      },
      legacyHint: 'Studdar að fullu — við myndum bara ekki velja þær fyrir nýja uppsetningu.',
      proto: {
        // La riga `usage` (Luca 2026-07-24) dice come TVirt usa il protocollo —
        // in primis i contenuti ammessi: dir/nfs/cifs ospitano dischi E immagini
        // ISO/disco e template, i driver a blocchi (iscsi/nvme-tcp/rbd) SOLO
        // dischi.
        dir: {
          name: 'Staðbundin mappa',
          desc: 'Mappa á hnútnum: einfalt og hratt. Hún er STAÐBUNDIN á einum hnút, nema slóðin sé raunverulega deild share — að merkja hana deilda þegar hún er það ekki kostar gögn.',
          usage: 'TVirt geymir þar diska VM-anna, ISO-/diskmyndir og sniðmát.'
        },
        nfs: {
          name: 'NFS',
          desc: 'NFS-export tengt af klasanum — deilt í eðli sínu.',
          usage: 'Hýsir diska VM-anna, ISO-/diskmyndir og sniðmát.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Windows/Samba-share tengt af klasanum — deilt í eðli sínu.',
          usage: 'Hýsir diska VM-anna, ISO-/diskmyndir og sniðmát.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Fjarlægt skráakerfi um SSH — án þarfar á NAS-exporti.',
          usage: 'Á vegvísinum.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'Blokkar-LUN um IP með deildu LVM ofan á.',
          usage: 'Aðeins diskar — eitt thin-volume á disk; hýsir hvorki ISO-myndir né sniðmát.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Dreifð blokkartæki á Ceph-klasa.',
          usage: 'Aðeins diskar — ein RBD-mynd á disk, opnuð beint af QEMU; hýsir ekki ISO-myndir.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Dreifða skráakerfi Ceph, tengt af kjarnanum á klasanum — deilt í eðli sínu.',
          usage: 'Hýsir VM-diska, ISO-/diskmyndir og sniðmát — dir-fjölskyldan á Ceph-skráakerfi (cephx-aðgangsupplýsingar skylda).'
        },
        fc: { name: 'SCSI/FC', desc: 'SCSI-LUN á FibreChannel-fabric — klassíska FC-SAN-ið.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'Sama SCSI á FibreChannel, með FC-rammana hjúpaða í Ethernet.' },

        // Vivo dal round #132 — la chiave è il nome del driver del contract,
        // così il chip della lista storage risolve la stessa voce.
        'iscsi-lun': {
          name: 'iSCSI (heil LUN)',
          desc: 'iSCSI-markmiðið sem beri heilla LUN: hver diskur ER LUN, afhent gestinum hrátt — ekkert LVM á milli.',
          usage: 'Aðeins diskar — eitt heilt LUN á disk, tekið yfir eins og það er; SAN-heimili diska með samnýtt skrif.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (heil nafnrými)',
          desc: 'NVMe-undirkerfið sem beri heilla nafnrýma: hver diskur ER nafnrými, afhent gestinum hrátt.',
          usage: 'Aðeins diskar — eitt heilt nafnrými á disk, tekið yfir eins og það er; samnýtt skrif já, SCSI persistent reservations nei.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'Fjarlægt NVMe — ekkert SCSI í leiðinni — á hreinu TCP, með deildu LVM ofan á.',
          usage: 'Aðeins diskar — eitt thin-volume á disk; hýsir hvorki ISO-myndir né sniðmát.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'Fjarlægt NVMe á FibreChannel-fabric.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe á FibreChannel-fabricinu sem FCoE flytur inni í Ethernet — FCoE- og NVMe/FC-lögin stöfluð.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI með gagnaleiðina færða á RDMA — hvaða fabric sem er (InfiniBand, iWARP, RoCE). Leyst af hólmi af NVMe/RDMA, enn til staðar í array-um og í ESXi.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'Innfætt SCSI á RDMA, tímabilið fyrir iSER: InfiniBand (með fabric-discovery) og RoCE — lifir áfram í öldruðum HPC-geymslum.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'Fjarlægt NVMe á hvaða RDMA-fabric sem er — InfiniBand, iWARP, RoCE v1 og v2: ein stilling, hnúturinn segir hvað hann hefur.' },
        s3: { name: 'S3', desc: 'S3-samhæf hlutageymsla — myndir og öryggisafrit.' }
      }
    },
    catalogs: {
      title: 'Katalógar',
      createTitle: 'Búa til katalóg',
      editTitle: 'Breyta katalógi',
      docTitle: 'Katalógur',
      notFound: 'Þessi katalógur er ekki til (lengur?)',
      scopeHint: 'Sá sem les þetta scope sér (og má nota) hverja skrá katalógsins',
      files: 'Skrár',
      noFiles: 'Engin skrá',
      count: {
        iso: 'ISO',
        ctRootfs: 'CT-tpl',
        vmTemplate: 'VM-tpl',
        ociImage: 'OCI',
        firmwareOvmf: 'Fastbúnaður'
      },

      // Il catalogo di sistema (round #126): la casa degli oggetti integrati
      // della piattaforma — leggibile da tutti, scrivibile da nessuno.
      systemChip: 'kerfisins',
      systemTooltip: 'Kerfiskatalógur: hýsir innbyggða hluti vettvangsins og er ekki hægt að breyta'
    },

    // File di catalogo (round K1, inventory v2e/v2g): il catalogo è la casa
    // degli artefatti file del cluster — una lista, titoli per kind.
    catalogFiles: {
      catalog: 'Katalógur',
      kindLabel: 'Tegund',
      physicalSize: 'Raunstærð',
      virtualSize: 'Sýndarstærð',

      // Round K3 (#64) + K4 (#65, ova/ovf con la mappatura boot-survival):
      // materializza un file vm-template come VM Template dell'inventario.
      importTemplateAction: 'Flytja inn sem VM-sniðmát',
      importTemplateLegacy: 'Ekkert snið yfirlýst — nothæf sem seed fyrir diska, ekki innflytjanleg',
      importTemplateTitle: 'Flytja inn sem VM-sniðmát',
      importTemplateSubmit: 'Flytja inn',
      importTemplateError: 'Innflutningur mistókst',
      importTemplateHint: '.tvtpl-pakkinn verður að VM-sniðmáti: frysti vélbúnaður manifestsins auk eins disks á hverja færslu safnsins, hver sannreyndur gegn checksum-i sínu. NIC og CD/DVD-miðlar eru ekki hluti af safni — bættu þeim við eftir innflutninginn.',
      importTemplateQcow2Hint: 'Bert qcow2 verður að sniðmáti með EINUM diski og yfirlýstum sjálfgefnum vélbúnaði: linux-prófíll, UEFI, 2 vCPU, 2048 MiB, ræsing af eina disknum. Leiðréttu við deploy.',
      importTemplateName: 'Nafn sniðmátsins',
      importTemplateNameHint: 'Autt = {name} (-import-<n> sé það upptekið)',
      importTemplateStorage: 'Geymsla fyrir diskana',
      importTemplateMetadataStorage: 'Lýsigagnageymsla',
      importTemplateMetadataHint: 'Blokkargeymsla hýsir ekki VM-lýsigögnin (fastbúnað, varstore) — veldu dir/nfs/cifs-geymslu.',
      importTemplateStarted: 'Innflutningur hafinn — sniðmátið birtist í Sniðmát-flipanum þegar verkinu lýkur.',

      // Etichette parlanti al singolare (#86): findings e censimento dicono
      // COSA è il file — il generico 'File di catalogo' resta solo fallback.
      kind: {
        iso: 'ISO-mynd',
        'ct-rootfs': 'CT-rootfs',
        'vm-template': 'VM-sniðmát',
        'oci-image': 'OCI-mynd',
        'firmware-ovmf': 'OVMF-fastbúnaður'
      },
      title: {
        iso: 'ISO-myndir',
        'ct-rootfs': 'CT-sniðmát',
        'vm-template': 'VM-sniðmát',
        'oci-image': 'OCI-myndir',
        'firmware-ovmf': 'OVMF-fastbúnaður'
      },
      createTitle: {
        iso: 'Bæta við ISO-mynd',
        'ct-rootfs': 'Skrá CT-sniðmát',
        'vm-template': 'Bæta við VM-sniðmáti',
        'oci-image': 'Bæta við OCI-mynd',
        'firmware-ovmf': 'Bæta við OVMF-fastbúnaði'
      },
      formatHint: 'Leitt af endingu valinnar skrár — leiðréttu ef það giskaði rangt',
      tarballHint: 'Rootfs-tarball á staðlaða LXC-forminu (.tar.gz / .tar.xz / .tar.zst / .tar.bz2, eða einfalt .tar)',
      ociArchiveHint: 'Tarball docker-archive / oci-archive (.tar eða .tar.gz), til dæmis frá docker save',
      uploadResumeHint: 'Upphleðsla rofin — skráin bíður upphleðslu: sendu aftur með sömu skrá til að halda áfram',
      moveTitle: 'Flytja skrá',
      moveHint: 'Tvær óháðar víddir: Katalógur færir tengilinn (sama id, ekkert bæti færist, scope verður það sem áfangakatalógurinn hefur); Geymsla færir gögnin — hvert tengt afrit fylgir, hafnað meðan skráin er í notkun. Séu bæði valin: fyrst katalógurinn, svo geymslan.',
      moveCatalog: 'Áfangakatalógur',
      moveCatalogHint: 'Aðeins tengillinn skiptir um heimili: VM sem hefur skrána tengda verður að sjá áfangakatalóginn',
      keepCurrent: 'Ekki breyta',
      rehomed: 'Tengill færður í valinn katalóg',
      copyAction: 'Afrita í katalóg…',
      copyTitle: 'Afrita í katalóg',
      copyLinkHint: 'Afritið er ný tenging við sömu gögnin — ekkert er tvítekið á geymslunni.',
      copyCatalog: 'Áfangakatalógur',
      copyCatalogHint: 'Afritun er leiðin sem skrá ferðast milli katalóga',
      sameCatalog: 'Sá sami og uppsprettan',
      sharedObjectHint: 'Gögn þessarar skrár eru deild af {count} tengdum afritum',
      deleteLastLink: 'Þetta er SÍÐASTA tengingin við þetta innihald: gögnunum verður líka eytt af geymslunni.',
      deleteLinkOnly: 'Aðeins þessi tenging verður fjarlægð — gögnin sitja eftir, enn náanleg frá hinum tengdu afritunum ({count}).',
      noCatalog: 'Það er enginn katalógur — búðu til einn',
      inlineCatalogName: 'Nafn katalógsins',

      // File integrati nella piattaforma (round #126): storage null — si
      // leggono e si clonano, mai move/delete/rename.
      embeddedChip: 'innbyggt',
      embeddedStorage: 'Innbyggt í vettvanginn',
      embeddedNoMove: 'Innbyggð skrá vettvangsins: hún býr á engri geymslu — klónaðu hana í staðinn',
      embeddedCopyHint: 'Klónun raungerir innbyggðu bætin á alvöru geymslu: veldu áfangageymslu og -katalóg — afritið er venjuleg skrá',
      sourceEmbedded: 'Innbyggt í vettvanginn',
      nodesRow: 'Tilvist á hverjum hnút',
      nodesSummary: '{present} af {total} hnútum hafa það',
      nodePresent: 'til staðar',
      nodeMissing: 'vantar',
      nodeUnknown: 'ekki enn tilkynnt',
      nodesHint: 'Eignin býr á diski hvers hnúts (pakkinn trantor-tvirt-assets): hnútur sem hefur hana ekki getur hvorki skilgreint VM með þessum fastbúnaði né þjónað Guest Tools. Ólíkar útgáfur milli hnúta eru eðlilegar meðan á rúllandi uppfærslu stendur.',

      // Download (round #108): i byte viaggiano col loro permesso dedicato.
      downloadAction: 'Sækja',
      downloadNotReady: 'Innihaldið er ekki enn tilbúið — niðurhal krefst skrár í ready-stöðu',
      downloadDenied: 'Hlutverk þitt inniheldur ekki catalog.download — að sækja bætin er sérstakur réttur, aðskilinn frá notkun skrárinnar',

      // Round #156 (dialog standard): le righe di lettura mancanti del dialog
      // dettagli — i fatti dell'oggetto condiviso, il checksum dichiarato, gli
      // utilizzatori.
      objectRow: 'Geymsluhlutur',
      objectLinksRow: 'Tengd afrit',
      declaredChecksum: 'Yfirlýst SHA-256',
      usedByRow: 'Notað af',
      usedByVms: 'VM',
      usedByDisks: 'Diskar',
      transferRow: 'Flutningur',
      storageLockHint: 'Breytist aðeins með aðgerðinni Flytja'
    },

    // Il censimento per-storage (round K1, inventory v2b #2): sola lettura,
    // ogni oggetto si gestisce dalla sua sezione.
    objects: {
      action: 'Skoða innihald',
      title: 'Innihald geymslunnar',
      hint: 'Talning í lesham á því sem býr á þessari geymslu — hverjum hlut er stjórnað úr sínum hluta.',
      empty: 'Enginn hlutur skráður á þessari geymslu',
      loadError: 'Ekki tókst að sækja innihaldið',
      colDetail: 'Nánar',
      manage: 'Stjórna í sínum hluta',
      kind: {
        disk: 'Diskur',
        catalogFile: 'Katalógskrá',
        ociBlob: 'OCI-blob',
        checkpoint: 'Checkpoint',
        vmMetadata: 'VM-lýsigögn',
        appRoot: 'App-root',
        appVolume: 'App-volume'
      }
    },
    inventory: {
      tabCatalogs: 'Katalógar',
      storage: 'Geymsla',
      sizeGib: 'Stærð (GiB)',
      format: 'Snið',
      size: 'Stærð',
      sourceType: 'Uppspretta',
      sourceFile: 'Skráarupphleðsla',
      sourceUrl: 'Niðurhal frá URL',
      file: 'Skrá',
      url: 'URL',
      checksum: 'SHA-256 checksum',
      checksumHint: 'Skylda: niðurhalið er sannreynt gegn þessu SHA-256',
      verifyChecksum: 'Sannreyna checksum',
      checksumOffHint: 'Niðurhalið verður samþykkt án sannprófunar — reiknaða SHA-256 er samt skráð',
      uploading: 'Hleð upp…',
      move: {
        action: 'Flytja',
        diskTitle: 'Flytja disk',
        target: 'Áfangageymsla',
        diskHint: 'Diskurinn heldur auðkenni sínu: bætin ferðast í völdu geymsluna. VM sem notar hann verður að vera slökkt; með skyndimyndir til staðar hafnar iSCSI-hlið flutningnum.',
        noTargets: 'Engin samhæf áfangageymsla',
        submit: 'Flytja',
        error: 'Flutningnum var hafnað'
      },
      clone: {
        action: 'Klóna',
        title: 'Klóna disk',
        name: 'Nafn afritsins',
        storage: 'Áfangageymsla',
        sameStorage: 'Sú sama og uppsprettan',
        linked: 'Linked clone',
        linkedHint: 'Tafarlaus qcow2-overlay hlekkjuð við upprunadiskinn (aðeins qcow2-uppsprettur). Sjálfgefið er fullt afrit.',
        linkedCrossHint: 'Linked clone situr áfram á geymslu uppsprettunnar: veldu „Sú sama og uppsprettan“ til að virkja hana.',
        submit: 'Klóna',
        error: 'Klónuninni var hafnað'
      },
      copy: {
        action: 'Afrita',
        name: 'Nafn afritsins',
        storage: 'Áfangageymsla',
        sameStorage: 'Sú sama og uppsprettan',
        submit: 'Afrita',
        error: 'Afrituninni var hafnað'
      },
      taskStarted: 'Hafið — heldur áfram sem verk í bakgrunni',
      cephObjects: 'Fara í nánari upplýsingar hlutarins á Ceph',
      phase: {
        ready: 'Tilbúin',
        creating: 'Í stofnun',
        'awaiting-upload': 'Bíður upphleðslu',
        downloading: 'Í niðurhali',
        verifying: 'Í sannprófun',
        deleting: 'Í eyðingu',
        error: 'Villa',
        'in-use': 'Í notkun'
      }
    }
  }
}
